import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis, scrollTo } from './lenis'

gsap.registerPlugin(ScrollTrigger)

export const articles = () => {

	const el = document.querySelector('.articles')

	if (!el) return

	htmx.on('htmx:beforeRequest', (e) => {
		gsap.to('.articles__listing', {
			duration: 0.35,
			y: -25,
			opacity: 0,
			ease: 'power2',
			onComplete: () => {
			}
		})
		lenis.scrollTo('body', {
			duration: 1.5,
			offset: 0
		})
	})
	htmx.on('htmx:afterSwap', () => {
		gsap.fromTo('.articles__listing', {
			y: -25,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 0.35,
			ease: 'power2'
		})
	})
}

export default () => {} 